export default {
  typeMessage: 'Type message...',
  send: 'Send',
};
